const url = 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/'
const assId = null

export default {
  url,
  assId
}



// WEBPACK FOOTER //
// ./src/api/global.js